/**
 * ProblemNumber — 미리보기의 **문제 번호 한 칸**.
 *
 * 신형 미리보기 둘(모달 ProblemPreviewV2 · 카드 ProblemCardsV2)이 같은 번호를 그린다.
 * 마크업과 색을 각자 두면 한쪽만 고쳐도 빌드는 통과하고 화면도 떠서 조용히 갈린다 —
 * 이 저장소가 이미 그렇게 갈려 있다: 구형 모달(ProblemPreview.js:463)과 구형 카드
 * (ProblemPreviewCards.js:507)에 **같은 세 줄이 두 벌** 있고, 한쪽은 `=== null` 만 보고
 * 다른 쪽은 `undefined` 까지 본다. 그 둘은 오너 지시로 손대지 못하므로(2026-08-26)
 * 여기서 한 벌로 모으고, **넓은 쪽 판정**(null·undefined 둘 다 무채색)을 택한다.
 *
 * ── 색은 「학생이 맞았나」이지 「정답이 무엇인가」가 아니다 ──────────────────
 * 이 값은 문제의 속성이 아니라 **그 학생의 그 시험 기록**에서 온다. 그래서 문제은행을
 * 보는 자리(문제 /problem-hub · 시험지 /exam-papers)는 이 칸에 색을 줄 것이 없고, 학생 화면에서만 색이 산다.
 * 값이 없을 때 초록도 빨강도 아닌 검정인 이유가 그것이다 — 모르는 것을 맞았다고 하지 않는다.
 */

/* eslint-disable no-restricted-syntax -- 구형 미리보기 두 벌이 쓰던 실측 색 그대로다(오너: 디자인 그대로).
   초록은 tailwind primary(#4ABC85)와 같은 값이지만 빨강은 danger(#DC2626)와 다르다 —
   토큰으로 바꾸면 빨강만 얼굴이 바뀌므로 둘 다 리터럴로 둔다. */
/** 맞은 문제 — tailwind `primary.DEFAULT` 와 같은 값이다 */
const CORRECT = '#4ABC85';
/** 틀린 문제 — **`danger.DEFAULT`(#DC2626) 가 아니다.** 구형이 쓰던 값이 이것이라 그대로 둔다 */
const WRONG = '#F9344B';
/** 정오답을 모르는 자리(문제은행) */
const UNKNOWN = '#000000';
/* eslint-enable no-restricted-syntax */

/**
 * @param number    화면에 쓸 번호. 2자리로 0을 채운다(구형과 같다 — 「01」).
 * @param isCorrect true 맞음 · false 틀림 · null|undefined 모름(무채색)
 * @param minWidth  번호 칸의 최소 폭(px). 구형 모달이 36, 구형 카드가 36 이다.
 */
function ProblemNumber({ number, isCorrect = null, minWidth = 36 }) {
  const color = isCorrect == null ? UNKNOWN : (isCorrect ? CORRECT : WRONG);
  return (
    <span
      className="shrink-0 text-2xl font-bold leading-none"
      style={{ color, minWidth }}
    >
      {String(number).padStart(2, '0')}
    </span>
  );
}

export default ProblemNumber;
